import React from "react";
import "../css/areastematicas.css";

const areas = [
  "Botánica y etnobotánica de plantas medicinales.",
  "Farmacología y etnofarmacología de especies medicinales.",
  "Fitoquímica y química de especies medicinales.",
  "Control de calidad, desarrollo, innovación y marco regulatorio de plantas medicinales.",
  "Química medicinal, química verde, relación estructura-actividad (SAR-QSAR) y estudios in silico de principios activos de plantas medicinales.",
  "Biotecnología, mejoramiento genético, cultivo, conservación y propagación de plantas medicinales.",
  "Genómica, metabolómica y transcriptómica aplicadas a la obtención de principios bioactivos de plantas medicinales.",
  "Terapéutica y ensayos clínicos con plantas medicinales.",
  "Gobernanza e institucionalidad para el acceso legal a recursos biológicos y genéticos de plantas medicinales y su conservación y uso sostenible.",
  "Bioeconomía y cadenas de valor en productos naturales de plantas medicinales."
];

function AreasTematicas() {
  return (
    <section className="areas-container">
      <h2 className="areas-title">Áreas <b>temáticas</b></h2>
      <p className="areas-description">
        Las áreas temáticas que se desarrollan en el evento son tópicos concernientes a:
      </p>

      <div className="areas-grid">
        {areas.map((area, index) => (
          <div key={index} className="area-card">
            <span className="area-number">{index + 1}</span>
            <p>{area}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default AreasTematicas;